import { Form } from "@circle-react-uikit/Form";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { OtpHeader } from "@circle-react/components/OtpChallenge/components/OtpHeader";
import { OtpTitle } from "@circle-react/components/OtpChallenge/components/OtpTitle";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useResetPassword } from "@circle-react/hooks/useResetPassword";
import { useState } from "react";

import type { CurrentCommunity } from "@/react/types/CurrentCommunity";

import { PASSWORD_FIELD_NAME } from "./constants";
import { PasswordFields } from "./PasswordFields";

interface CreatePasswordStepProps {
  className?: string;
  community?: CurrentCommunity | null;
  email: string;
  onCancel: () => void;
  onError?: () => void;
  onSuccess?: () => void;
}

export const CreatePasswordStep = ({
  email,
  onCancel,
  onSuccess,
  onError,
  community = null,
  className,
}: CreatePasswordStepProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { mutate: resetPassword } = useResetPassword({
    setIsResettingPassword: setIsSubmitting,
    endpoint: authenticationAppRoutes.passwordSetup(),
    options: { onSuccess, onError },
  });

  return (
    <div
      className={classNames(
        "flex h-full flex-col items-center justify-center",
        className,
      )}
    >
      {community && <OtpTitle currentCommunity={community} />}
      <div className="text-primary w-full rounded-lg border border-primary p-6 sm:w-[468px]">
        <OtpHeader
          email={email}
          onCancel={onCancel}
          isDisabled={isSubmitting}
        />

        <Form
          defaultValues={{ [PASSWORD_FIELD_NAME]: "" }}
          onSubmit={(values: { password: string }) => {
            resetPassword({
              user: {
                password: values.password,
                // Single-field UX: there is no separate confirm input, so we
                // mirror the password to satisfy the server's
                // validates_confirmation_of :password. The confirmation check
                // is intentionally a no-op for this flow.
                password_confirmation: values.password,
              },
            });
          }}
        >
          <PasswordFields isSubmitting={isSubmitting} />
        </Form>
      </div>
    </div>
  );
};

CreatePasswordStep.displayName = "CreatePasswordStep";
